import { IObraPagedResponse } from "models/response/obra-paged-response";

export interface ObraDetailsState {
  obraDetails: IObraPagedResponse | null;
  loading: boolean;
  error: string | null;
}

export const ACTION_TYPES = {
  setObraDetails: 'setObraDetails',
  setLoading: 'setLoading',
  setError: 'setError',
} as const;

type ActionType = keyof typeof ACTION_TYPES;

export interface ObraDetailsAction {
  type: ActionType;
  payload: any;
}

export const ObraDetailsReducer = (
  state: ObraDetailsState,
  action: ObraDetailsAction
): ObraDetailsState => {
  switch (action.type) {
    case ACTION_TYPES.setObraDetails:
      return { ...state, obraDetails: action.payload, error: null };
    case ACTION_TYPES.setLoading:
      return { ...state, loading: action.payload };
    case ACTION_TYPES.setError:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};
